'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.Navigations = void 0;
var transport_1 = require("../../transport");
var Navigations = /** @class */ (function () {
    function Navigations() {
    }
    Navigations.prototype.getNavigations = function (params) {
        return transport_1.transport.request('navigations/getAll', params);
    };
    return Navigations;
}());
exports.Navigations = Navigations;
